const addValidators = function() {};

export default {
  classNames: {},
  events: 'blur',
  addValidators,
};
